import React, { useState, useEffect, useRef, useContext } from 'react';
import '../styles/App.css';
import '../i18n';
import { NavigationContext } from '../context/NavigationContext';
import { UserContext } from '../context/UserContext';

export const HeaderMenu: React.FC<{ onMenuClick: () => void }> = ({ onMenuClick }) => {
    const context = useContext(NavigationContext);
    if (!context) {
        throw new Error('HeaderMenu must be used within a NavigationProvider');
    }
    const { navigateTo } = context;

    const userContext = useContext(UserContext);
    if (!userContext) {
        throw new Error('HeaderMenu must be used within a UserProvider');
    }
    const { currentUser } = userContext;

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setIsMenuOpen(false);
        }
    };

    useEffect(() => {
        if (isMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpen]);

    return (
        <header className="App-header">
            <div className="header-left">
                <button className="burger-menu" aria-label="Menu" onClick={onMenuClick}>
                    ☰
                </button>
                {/* <button className="messages-button" aria-label="Messages">
                    💬
                </button> */}
            </div>
            <div className="header-center">
                <span className="beta-label">Schatzmeister Toolbox</span>
            </div>
            <div className="header-right" ref={menuRef}>
                <img
                    src={currentUser.image || '/profile-picture.png'}
                    alt="Profile"
                    className="profile-picture"
                    onClick={toggleMenu}
                />
                {isMenuOpen && (
                    <div className="overlay-menu">
                        <button
                            className="privacy-button"
                            onClick={() => {
                                navigateTo('/my-profile');
                                setIsMenuOpen(false);
                            }}
                        >
                            👤 {currentUser.name}
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
};